import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ControlTip } from "Components/ControlTip";
import { setAccountInfo } from "Store/appStore/action";
import { getStore, setStore } from "Pub/js/storageUtils";
import { Select } from "antd";
import Ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils";
import GroupSwitch from "./GroupSwitch";
const Option = Select.Option;
class GroupSelection extends React.Component {
    constructor(props) {
        super(props);
    }
    /**
     * 刷新整个页面
     */
    refreshThePage = () => {
        window.location.reload(true);
    };
    /**
     * 清空模板缓存数据
     */
    ckearTempletStorage = () => {
        for (let iterator of Object.keys(window.localStorage)) {
            if (iterator.indexOf("appTempletStorage_") > -1) {
                window.localStorage.removeItem(iterator);
            }
        }
    };
    /**
     * 组织切换
     * @param {String} value 选中组织的value值
     */
    handleChange = value => {
        ControlTip({
            status: "warning",
            title: langCheck("0000PUB-000106") /* 国际化处理： 请注意！*/,
            msg: langCheck(
                "0000PUB-000107"
            ) /* 国际化处理： 切换集团将会重新加载数据。*/,
            onOk: () => {
                let selectedGroup = this.props.currentData.find(
                    item => item.pk_group === value
                );
                Ajax({
                    url: `/nccloud/platform/appregister/switchgroup.do`,
                    data: {
                        pk_group: value,
                        groupName: selectedGroup.groupName,
                        groupCode: selectedGroup.groupCode
                    },
                    info: {
                        name: langCheck(
                            "0000PUB-000109"
                        ) /* 国际化处理： 工作桌面*/,
                        appcode: "10228888",
                        action: langCheck(
                            "0000PUB-000110"
                        ) /* 国际化处理： 集团切换*/
                    },
                    success: ({ data: { data } }) => {
                        console.log(data)
                        if (data.msg) {
                            this.props.setAccountInfo({ selectedKey: value });
                            sessionStorage.setItem('noCacheBrowserTabs', '1');
                            // 切换集团清除模板缓存数据
                            this.ckearTempletStorage();
                            window.localStorage.removeItem('STOREFORINFODATA');
                            window.localStorage.removeItem('COLLAPSEDFIELDS');
                            this.removeMenuCache(); // 清除菜单缓存
                            window.localStorage.removeItem('workbenchNavs'); // 清除导航栏工作台缓存
                            window.localStorage.removeItem("NCC_IMData"); // 清除IM缓存
                            // 切换集团之后重新查询业务日期
                            this.refreshThePage();
                        }
                    }
                });
            },
            zIndex: 1000 // 需要大于个人信息侧拉的层级
        });
    };

    removeMenuCache() {
        const menuCacheKeys = Object.keys(window.localStorage).filter(key => key === 'appModuleMenus' || key.startsWith('moduleMenus'));
        menuCacheKeys.forEach(key => {
            window.localStorage.removeItem(key)
        })
    }

    render() {
        let { groupId, currentData = [], showIcon, groupSelectShow, onGroupSwitchClick } = this.props;
        let gName = currentData.find(item => item.pk_group == groupId);
        const selectStyle = {
            // width: 234,
            display: groupSelectShow ? 'block' : 'none'
        }
        return (
            <div
                fieldid="group-switch" //自动化测试用标记
                className={`nc-workbench-group-switch ${
                    showIcon && groupSelectShow ? "show-icon" : ""
                }`}
                ref="ncWorkbenchGroupSwitch"
            >
                {showIcon ? (
                    <GroupSwitch groupName={gName ? gName.groupName : ""} onClick={onGroupSwitchClick}/>
                ) : null}
                <Select
                    className="fieldid_group"
                    dropdownClassName="fieldid_group_select" //自动化测试用标记
                    getPopupContainer={() =>
                        this.refs["ncWorkbenchGroupSwitch"]
                    }
                    value={groupId}
                    style={selectStyle}
                    onChange={this.handleChange}
                    disabled={groupId === ""} //系统管理员禁用
                >
                    {currentData.map(item => {
                        return (
                            <Option
                                title={item.groupName}
                                key={item.pk_group}
                                value={item.pk_group}
                            >
                                {item.groupName}
                            </Option>
                        );
                    })}
                </Select>
            </div>
        );
    }
}
GroupSelection.propTypes = {
    currentData: PropTypes.array.isRequired,
    groupId: PropTypes.string.isRequired,
    setAccountInfo: PropTypes.func.isRequired
};
export default connect(
    state => ({
        currentData: state.appData.currentData,
        groupId: state.appData.groupId
    }),
    { setAccountInfo }
)(GroupSelection);
